<template>
  <div class="home">
    <Nav></Nav>
    <header class="header">
      <div class="header-content">
        <div class="flex-center">
          <ProgressiveImage
            :high-res-src="bannerImages.default"
            :placeholder-src="bannerLoadingImages.default"
            image-class="banner-image"
            container-class="hidden-lg-only hidden-md-only hidden-sm-only hidden-xs-only banner-container"
            data-aos="fade-in"
            alt="渲酷云渲染平台"
            @loaded="onBannerLoaded"
            @error="onBannerError">
          </ProgressiveImage>
          <ProgressiveImage 
            :high-res-src="bannerImages.md"
            :placeholder-src="bannerLoadingImages.md"
            image-class="banner-image"
            container-class="hidden-xl-only hidden-sm-only hidden-xs-only banner-container"
            alt="渲酷云渲染平台"
            @loaded="onBannerLoaded"
            @error="onBannerError">
          </ProgressiveImage>
          <ProgressiveImage 
            :high-res-src="bannerImages.sm"
            :placeholder-src="bannerLoadingImages.sm"
            image-class="banner-image banner-image-position"
            container-class="hidden-xl-only hidden-lg-only hidden-md-only hidden-xs-only banner-container"
            alt="渲酷云渲染平台"
            @loaded="onBannerLoaded"
            @error="onBannerError">
          </ProgressiveImage>
          <ProgressiveImage 
            :high-res-src="bannerImages.xs"
            :placeholder-src="bannerLoadingImages.xs"
            image-class="banner-image banner-image-position"
            container-class="hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only banner-container"
            alt="渲酷云渲染平台"
            @loaded="onBannerLoaded"
            @error="onBannerError">
          </ProgressiveImage>
        </div>
        <div class="text-container">
          <div class="header-main">
            <p class="text-slogan">
              <span class="text-color">更快、更省</span><span>的硬“核”渲染平台</span>
            </p>
            <!-- <div class="register-input flex-center">
              <el-input 
                placeholder="请输入手机号"  
                type="text" 
                v-model.number="phone" 
                maxlength="11"
                oninput="value=value.replace(/[^\d]/g,'')" 
                class="input-with-select"
                @keyup.enter.native="registerClick"
                clearable>
                  <el-button class="input-append" 
                  slot="append" 
                  type="success"  
                  @click="registerClick"
                  >领20元代金券</el-button>
              </el-input>
            </div> -->
          </div>
        </div>
      </div>
    </header>
    <!-- 工作助手 -->
    <section class="section home-feature" data-aos="fade-up" data-aos-duration="1000">
      <div class="subtitle hidden-xs-only">建筑可视化行业的贴身管家、设计师的得力助手</div>
      <div class="subtitle hidden-sm-and-up">建筑可视化行业的贴身管家<br/>设计师的得力助手</div>
      <p class="subtitle-desc">后续将会支持更多软件</p>
      <!-- 支持软件 -->
      <el-row class="container software-list">
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item">
              <div class="software-img">
                <img :src="softwareImages.max3ds" alt="">
              </div>
              <p class="software-text">3ds Max</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item">
              <div class="software-img">
                <img :src="softwareImages.corona" alt="">
              </div>
              <p class="software-text">Corona</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item last-software-item">
              <div class="software-img">
                <img :src="softwareImages.vray" alt="">
              </div>
              <p class="software-text">V-Ray</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="6" :xl="6">
          <div class="flex-center flex-align-center">
            <div class="software-item last-software-item">
              <div class="software-img">
                <img :src="softwareImages.sketchup" alt="">
              </div>
              <p class="software-text">Sketchup</p>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 支持软件结束 -->
      <!-- 功能开始 -->
      <div class="container">
        <ul class="function-list flex-align-center">
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img :src="functionImages.submit" alt="">
              </div>
              <p class="function-text">一键提交</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img :src="functionImages.ao" alt="">
              </div>
              <p class="function-text">AO/通道</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img :src="functionImages.camera" alt="">
              </div>
              <p class="function-text">多相机渲染</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img :src="functionImages.photon" alt="">
              </div>
              <p class="function-text">智能光子</p>
            </div>
          </li>
          <li class="flex-center function-item">
            <div class="function">
              <div class="function-img">
                <img :src="functionImages.preview" alt="">
              </div>
              <p class="function-text">实时预览</p>
            </div>
          </li>
          <li class="flex-center last-function function-item hidden-md-and-up">
            <div class="function ">
              <div class="function-img">
                <img :src="functionImages.more" alt="">
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 功能结束 -->
      <!-- 特色服务开始 -->
      <div class="container service-list flex-between">
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center service-item">
            <div class="">
              <div class="service-img">
                <img :src="serviceImages.server" alt="">
              </div>
              <p class="software-text">1w+服务器</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img :src="serviceImages.dispatch" alt="">
              </div>
              <p class="software-text">后台智能调度</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-support.png" alt="">
              </div>
              <p class="software-text">资深TD支持</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-security.png" alt="">
              </div>
              <p class="software-text">高效数据安全</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-center service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-rapidly.png" alt="">
              </div>
              <p class="software-text">极速传输</p>
            </div>
          </div>
        <!-- </el-col> -->
        <!-- <el-col :xs="12" :sm="8" :md="4" :lg="4" :xl="4"> -->
          <div class="flex-align-center flex-end service-item">
            <div class="">
              <div class="service-img">
                <img src="../assets/images/icon-custom.png" alt="">
              </div>
              <p class="service-text">定制化服务</p>
            </div>
          </div>
        <!-- </el-col> -->
      </div>
      <!-- 特色服务结束 -->
    </section>
    <!-- 工作助手结束 -->
    <!-- 注册按钮 -->
    <!-- <section class="flex-center download-now">
      <div class="">
        <p class="download-header">注册就送20元无门槛渲染费</p>
        <a target="_blank" href="https://s.rendercool.com/#/register?flag=register"><div class="download-btn">点击领取</div></a>
      </div>
    </section> -->
    <!-- 注册按钮结束 -->
    <!-- 新闻资讯 -->
    <section class="container news-list" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <div class="subtitle">渲酷云渲染热点资讯</div>
      <el-row :gutter="18" class="news-box">
        <el-col class="news-item" 
          :xs="24" :sm="12" :md="8" :lg="8" :xl="8" 
          v-for="(news, index) in newsList" 
          :key="index">
          <el-skeleton :loading="loading" animated class="news-el-skeleton">
            <template slot="template">
              <el-skeleton-item variant="image" class="news-item-box" />
            </template>
            <template>
              <div class="news-item-box" @click="toDetail(news)">
                <img v-if="news.imgUrl" class="news-item-img" :src="news.imgUrl" alt="" />
                <div v-else class="news-item-img-placeholder flex-align-center flex-center">重要新闻</div>
                <div class="news-item-content">
                  <div class="news-item-title">{{news.title}}</div>
                  <p class="news-item-time">{{news.setTime}}</p>
                </div>
              </div>
            </template>
          </el-skeleton>
        </el-col>
      </el-row>
    </section>
    <!-- 新闻资讯结束 -->
    <!-- 案例展示 -->
    <section class="container case-list" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <div class="subtitle">案例展示</div>
      <el-carousel :interval="4000" type="card" :height="carouselHeight">
        <el-carousel-item v-for="item in carouselList" :key="item.id">
          <img style="width: 100%;" :src="item.url" alt="">
        </el-carousel-item>
      </el-carousel>
    </section>
    <!-- 案例展示结束 -->
    <!-- 关于我们开始 -->
    <section class="aboutus-box" data-aos="fade-in" data-aos-duration="1000" data-aos-easing="ease-in-out">
      <ul>
        <li class="aboutus-item">
          <p class="aboutus-title">CONTACT US</p>
          <div class="flex-align-center flex-center ">
            <p class="flex-align-center aboutus-phone">
              <img class="mr5 aboutus-img " src="../assets/images/icon-phone.png" alt="">
              <span class="about-text">15083301945</span>
            </p>
            <p class="flex-align-center">
              <img class="mr5 aboutus-img" src="../assets/images/icon-qq.png" alt="">
              <span class="about-text">1478887151</span>
            </p>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">LINK</p>
          <div class="flex-align-center flex-center ">
            <a href="https://www.rendercool.com/" rel="noopener noreferrer" class="about-text">www.rendercool.com</a>
          </div>
        </li>
        <li class="aboutus-item">
          <p class="aboutus-title">ADD</p>
          <div class="flex-align-center flex-center ">
            <p class="about-text">浙江省衢州市龙游县金融中心A幢 15 楼</p>
          </div>
        </li>
      </ul>
      
    </section>
    <!-- 关于我们结束 -->
    <!-- 右下角固定按钮 -->
    <Position></Position>
    <footer class="flex-center footer-box">
      <div class="footer">
        Copyright © {{ year }} {{ localhost }} 备案号：<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">{{ recordNo }} </a>
        <a href="sitemap.htm">网站地图</a>
      </div>
    </footer>
  </div>
</template>

<script>
import Nav from '../components/Nav/index'
import Position from '../components/Position/index'
import ProgressiveImage from '../components/ProgressiveImage.vue'
import { bannerImages, softwareIcons, functionIcons, serviceIcons, carouselImages } from '../config/images'
export default {
  name: "Home",
  components: {
    Nav,
    Position,
    ProgressiveImage
  },
  data() {
    return {
      phone: '',
      showCpu: true,
      showGpu: true,
      showChat: true,
      year: new Date().getFullYear(),
      carouselList: carouselImages,
      newsList: [],
      loading: true,
      carouselHeight: '400px',
      screenWidth: window.innerWidth,
      queryParams: {
        pageNum: 1,
        pageSize: 3,
        type: '',
        newsType: 1, //  0：动画  1：效果图
      },
      localhost: 'www.rendercool.com',
      recordNo: '浙ICP备2025207059号-2',
    }
  },
  computed: {
    // 获取不同尺寸的banner图片URL
    bannerImages() {
      return bannerImages.responsive
    },
    // 获取不同尺寸的banner加载中图片URL
    bannerLoadingImages() {
      return bannerImages.loading
    },
    // 软件图标图片URL
    softwareImages() {
      return softwareIcons
    },
    // 功能图标图片URL
    functionImages() {
      return functionIcons
    },
    // 服务图标图片URL
    serviceImages() {
      return serviceIcons
    }
  },
  created() {
    this.handleResize();
    this.getNewsList();
    this.getRecordHost()
  },
  mounted() {
    console.log('resize', window.innerWidth)
     window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    getRecordHost() {

      let str = window.location.href.split('rendercool')[1]
      console.log('str', str)

      // 根据域名设置对应的备案号
      if (str === '.com') {
        this.localhost = 'www.rendercool.com'
        this.recordNo = '浙ICP备2025207059号-2'
      } else if (str === '.cn') {
        this.localhost = 'www.rendercool.cn'
        this.recordNo = '浙ICP备2025207059号-1'
      }
    },

    // Banner图片加载完成回调
    onBannerLoaded() {
      console.log('Banner图片加载完成')
      // 可以在这里添加AOS动画或其他逻辑
      if (this.$root.$options.aos) {
        this.$root.$options.aos.refresh()
      }
    },
    // Banner图片加载失败回调
    onBannerError() {
      console.warn('Banner图片加载失败，使用占位图')
    },
    registerClick () {
      if (this.phone) {
        window.open('https://s.rendercool.com/#/register?flag=register&phone='+this.phone)
      } else {
        window.open('https://s.rendercool.com/#/register?flag=register')
      }
    },
    handleResize() {
      this.screenWidth = window.innerWidth;
      if (this.screenWidth < 991) {
        this.showCpu = true
        this.showGpu = true
        this.carouselHeight = '100px'
      } else {
        this.showCpu = false
        this.showGpu = false
        if (this.screenWidth < 1440) {
          this.carouselHeight = '300px'
        } else {
          this.carouselHeight = '400px'
        }
      }
    },
    // 获取新闻列表
    getNewsList() {
      this.loading = true
      this.$axios.get('https://v.renderg.com/pub-api/news/list', { params: this.queryParams })
        .then(response => {
          console.log('response', response)
          if (response.data.code == 200) {
            this.newsList = response.data.rows
          } else {
            this.$message.error('没有更多数据')
            this.newsList = []
          }
        })
        .catch(error => {
          console.error(error)
          this.$message.error('获取新闻列表失败')
        })
        .finally(() => {
          this.loading = false
        })
    },
    toDetail(news) {
      let url = news.linkUrl
      window.open(url, '_blank')
    }
  },
};
</script>
<style lang="scss" scoped>
@import url('../style/news.scss');
</style>
